import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { evaluationItemType, referenceType } from 'constants/types';
import { WysiwygEditor } from 'components/Shared/sharedComponents';
import { Divider } from 'components/Shared/sharedStyle';
import StatusButtons from 'components/CandidateView/StatusButtons';
import { getDrivingSectionNum } from 'utils/candidateFormSections';
import { textBoxesRefsNames } from 'components/CandidateView/configCandidateView';

const DrivingLicense = ({ textBoxesRefs, defaultEvaluation, evaluation, updateEvaluationStatus }) => {
  const { t } = useTranslation();
  const sectionNumber = getDrivingSectionNum() + 1;
  const sectionTitle = t('candidateViewSection.drivingLicense');

  return (
    <>
      <h2>{`${sectionNumber}. ${sectionTitle}`}</h2>
      <WysiwygEditor
        defaultValue={defaultEvaluation?.comment}
        editorRef={textBoxesRefs}
        saveRefInAnotherRef
        name={textBoxesRefsNames?.drivingLicenseComment}
        sectionTitle={sectionTitle}
      />
      <StatusButtons value={evaluation} evaluationKey="drivingLicense" onClick={updateEvaluationStatus} />
      <Divider />
    </>
  );
};

DrivingLicense.propTypes = {
  textBoxesRefs: referenceType.isRequired,
  defaultEvaluation: evaluationItemType.isRequired,
  evaluation: PropTypes.number,
  updateEvaluationStatus: PropTypes.func.isRequired,
};

export default DrivingLicense;
